import { Component, computed, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { HelpButton, Badge } from 'excellence-ui';
import {
  CostForecastResponse,
  PriceForecastDetailsResponse,
  SupplierContractResponse,
} from '../../../../core/clients/omni-core/models';
import { SupplierContractPriceRangePipe } from '../../pipes/supplier-contract-price-range-pipe';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { SummaryCardView } from './definitions';

@Component({
  selector: 'app-supplier-contract-price-total-card',
  imports: [HelpButton, TranslocoPipe, Badge, SupplierContractPriceRangePipe, GermanNumberPipe],
  templateUrl: './supplier-contract-price-total-card.html',
})
export class SupplierContractPriceTotalCard {
  supplierContract = input.required<SupplierContractResponse | null | undefined>();

  view = input.required<SummaryCardView>();

  selectedYear = input.required<number>();
  selectedEnergyInterfaceID = input.required<string | undefined>();

  price = input.required<PriceForecastDetailsResponse | null | undefined>();
  cost = input.required<CostForecastResponse | null | undefined>();

  protected totalConsumption = computed(
    () => this.price()?.totalConsumption ?? this.cost()?.totalConsumption ?? 0,
  );

  protected energyPrice = computed(() => this.price()?.totalPrice ?? { min: 0, max: 0 });
  protected energyCost = computed(() => this.cost()?.totalEnergyCost ?? { min: 0, max: 0 });

  protected supplyPrice = computed(
    () => this.price()?.totalPriceByOrigin?.SUPPLY ?? { min: 0, max: 0 },
  );
  protected supplyCost = computed(
    () => this.cost()?.totalCostByOrigin?.SUPPLY ?? { min: 0, max: 0 },
  );

  protected taxesPrice = computed(
    () => this.price()?.totalPriceByOrigin?.TAXES ?? { min: 0, max: 0 },
  );
  protected taxesCost = computed(() => this.cost()?.totalCostByOrigin?.TAXES ?? { min: 0, max: 0 });

  protected gridPrice = computed(
    () => this.price()?.totalPriceByOrigin?.GRID ?? { min: 0, max: 0 },
  );
  protected gridCost = computed(() => this.cost()?.totalCostByOrigin?.GRID ?? { min: 0, max: 0 });

  protected meteringPrice = computed(
    () => this.price()?.totalPriceByOrigin?.METERING ?? { min: 0, max: 0 },
  );
  protected meteringCost = computed(
    () => this.cost()?.totalCostByOrigin?.METERING ?? { min: 0, max: 0 },
  );
}
